import React from 'react';
import { styled } from 'dripsy';
import { View } from 'react-native';

import { BaseText } from './BaseText';
import { Touchable, ITouchableProps } from './Touchable';
import { ColorType } from '@types';
import { Icon } from './Icon';
import { Separator } from './Separator';

interface IActivePropsStyle {
  isActive: boolean;
  disabled: boolean;
}

function backgroundColor(props: IActivePropsStyle): ColorType {
  if (props.disabled) {
    if (props.isActive) {
      return '$primary80';
    } else {
      return '$background0';
    }
  } else {
    if (props.isActive) {
      return '$primary80';
    } else {
      return '$background0';
    }
  }
}

function borderColor(props: IActivePropsStyle): ColorType {
  if (props.disabled) {
    if (props.isActive) {
      return '$background30';
    } else {
      return '$background30';
    }
  } else {
    if (props.isActive) {
      return '$primary300';
    } else {
      return '$text400';
    }
  }
}

const TouchableContainer = styled(Touchable)(
  (props: IActivePropsStyle) => ({
    px: '$6',
    py: '$5',
    bg: backgroundColor(props),
    borderWidth: 1,
    borderColor: props.isActive ? '$primary80' : '$background30',
    borderRadius: 12,
    justifyContent: 'center',
  }),
);

const IconContainer = styled(View)((props: IActivePropsStyle) => ({
  justifyContent: 'center',
  alignItems: 'center',
  size: 20,
  borderRadius: 'full',
  borderWidth: 1,
  borderColor: borderColor(props),
  backgroundColor: props.isActive ? '$primary300' : '$background0',
}));

const RowContainer = styled(View)({
  flexDirection: 'row',
  alignItems: 'center',
});

const Text = styled(BaseText)((props: IActivePropsStyle) => ({
  color: props.disabled ? '$text80' : '$heading800',
  variant: 'text.medium',
  fontWeight: 'semi',
}));

export interface IOptionItemProps extends ITouchableProps {
  value?: boolean;
  disabled?: boolean;
  text?: string;
  onValueChange?: (value: boolean) => void;
}

export function OptionItem({
  children,
  value = false,
  disabled = false,
  text,
  onValueChange,
  ...props
}: IOptionItemProps) {
  const isText = !!text;

  function toggleStatus() {
    if (onValueChange) {
      onValueChange(!value);
    }
  }

  return (
    <TouchableContainer
      isActive={value}
      disabled={disabled}
      onPress={toggleStatus}
      {...props}
    >
      <RowContainer>
        <IconContainer isActive={value} disabled={disabled}>
          {value && (
            <Icon name="done-light" color="$background0" size={16} />
          )}
        </IconContainer>
        <Separator vertical size="$4" />
        {isText && (
          <Text isActive={value} disabled={disabled}>
            {text}
          </Text>
        )}
        {children}
      </RowContainer>
    </TouchableContainer>
  );
}
